import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Bold = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 16 20' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M1 2.895C1 1.853 1.884 1 2.965 1h5.03c2.574 0 4.667 2.018 4.667 4.5S10.569 10 7.995 10H1z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M1 10h9.333C12.907 10 15 12.018 15 14.5S12.907 19 10.333 19H2.965C1.885 19 1 18.147 1 17.105z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          d='M1 2.895C1 1.853 1.884 1 2.965 1h5.03c2.574 0 4.667 2.018 4.667 4.5S10.569 10 7.995 10H1z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M1 10h9.333C12.907 10 15 12.018 15 14.5S12.907 19 10.333 19H2.965C1.885 19 1 18.147 1 17.105z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    )}
  </IconBase>
);
